export default __webpack_public_path__ + "static/media/door_ball.3ed491a0.jpg";